import * as React from "react";
import styled from "styled-components";
import { Flex } from "rebass";
import { ActiveIndicator } from "../../images/icons/ActiveIndicator";

const Container = styled(Flex)<{
  isSideBarOpen: boolean;
  disabled?: boolean;
}>`
  width: ${({ isSideBarOpen }) => (isSideBarOpen ? "184px" : "72px")};
  height: 40px;
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};

  &:hover {
    background: ${({ disabled }) =>
      disabled ? "transparent" : "rgba(255, 255, 255, 0.05)"};
  }
`;

const ContentContainer = styled.div<{
  isActive?: boolean;
  disabled?: boolean;
}>`
  display: flex;
  margin-left: ${({ isActive }) => (isActive ? "24px" : "26px")};
  justify-content: center;
  align-items: center;

  font-weight: ${({ isActive }) => (isActive ? "800" : "normal")};
  font-size: 16px;
  line-height: 24px;
  color: ${({ isActive, disabled }) => {
    if (isActive) return "#FFFFFF";
    if (disabled) return "#4A5568";
    return "#6E7D92";
  }};
`;

const IconContainer = styled.div`
  display: flex;
  margin: 0 18px 0 0;

  // & > svg:hover,
  // & > svg > path:hover {
  //   fill: ${({ theme }) => theme.newColors.grayscale.tertiaryGray};
  // }
`;

const NameContainer = styled.div``;

const Indicator = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
`;

export const SideBarAction = (props: SideBarActionProps) => {
  const { icon, name, isActive, onClick, isSideBarOpen, disabled } = props;
  const effectiveIsActive = isActive && !disabled;

  const handleClick = (): void => {
    if (!disabled && onClick) {
      onClick();
    }
  };

  return (
    <Container
      onClick={handleClick}
      isSideBarOpen={isSideBarOpen}
      disabled={disabled}
    >
      {effectiveIsActive && (
        <Indicator>
          <ActiveIndicator />
        </Indicator>
      )}
      <ContentContainer isActive={effectiveIsActive} disabled={disabled}>
        <IconContainer>{icon}</IconContainer>
        {isSideBarOpen && <NameContainer>{name}</NameContainer>}
      </ContentContainer>
    </Container>
  );
};

type SideBarActionProps = {
  name: string;
  isSideBarOpen: boolean;
  icon: React.ReactNode;
  isActive?: boolean;
  onClick?: () => void;
  disabled?: boolean;
};
